/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_Already_ClaimedInputs */

const en_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This account is already set up. Sign in or use Forgot password.`)
};

const es_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta cuenta ya está configurada. Inicia sesión o usa Olvidé mi contraseña.`)
};

const de_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Konto ist bereits eingerichtet. Melden Sie sich an oder verwenden Sie „Passwort vergessen“.`)
};

const zh_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该账户已设置。请登录或使用“忘记密码”。`)
};

const ar_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا الحساب مُعدّ مسبقاً. سجّل الدخول أو استخدم نسيت كلمة المرور.`)
};

const fr_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce compte est déjà configuré. Connectez-vous ou utilisez Mot de passe oublié.`)
};

const vi_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản này đã được thiết lập. Đăng nhập hoặc dùng Quên mật khẩu.`)
};

const sw_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaunti hii tayari imesanidiwa. Ingia au utumie Umesahau nenosiri.`)
};

const th_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชีนี้ได้รับการตั้งค่าแล้ว เข้าสู่ระบบหรือใช้ ลืมรหัสผ่าน`)
};

const bs_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ovaj račun je već postavljen. Prijavite se ili koristite Zaboravljena lozinka.`)
};

const ja_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアカウントはすでに設定済みです。サインインするか、「パスワードをお忘れですか？」をご利用ください。`)
};

const ko_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 설정된 계정입니다. 로그인하거나 '비밀번호를 잊으셨나요?'를 이용하세요.`)
};

const pt_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta conta já está configurada. Entre ou use “Esqueceu a senha?”.`)
};

const it_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo account è già configurato. Accedi o usa Password dimenticata.`)
};

const sv_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det här kontot är redan konfigurerat. Logga in eller använd Glömt lösenord.`)
};

const nl_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit account is al ingesteld. Log in of gebruik Wachtwoord vergeten.`)
};

const da_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne konto er allerede oprettet. Log ind eller brug Glemt adgangskode.`)
};

const nb_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne kontoen er allerede satt opp. Logg inn eller bruk Glemt passord.`)
};

const fi_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä tili on jo otettu käyttöön. Kirjaudu sisään tai käytä Unohditko salasanan -toimintoa.`)
};

const pl_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To konto jest już skonfigurowane. Zaloguj się lub użyj opcji „Zapomniałeś hasła?”.`)
};

const ru_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот аккаунт уже настроен. Войдите или воспользуйтесь функцией «Забыли пароль?».`)
};

const tr_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu hesap zaten kurulmuş. Giriş yapın veya Şifremi unuttum seçeneğini kullanın.`)
};

const hi_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह खाता पहले से सेट है। साइन इन करें या 'पासवर्ड भूल गए?' का उपयोग करें।`)
};

const id_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun ini sudah diatur. Masuk atau gunakan Lupa kata sandi.`)
};

const ms_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaun ini sudah disediakan. Log masuk atau gunakan Lupa kata laluan.`)
};

const cs_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento účet je již nastavený. Přihlaste se nebo použijte Zapomenuté heslo.`)
};

const el_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αυτός ο λογαριασμός έχει ήδη ρυθμιστεί. Συνδεθείτε ή χρησιμοποιήστε την επιλογή «Ξεχάσατε τον κωδικό;».`)
};

const he_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`החשבון הזה כבר הוגדר. התחברו או השתמשו באפשרות ״שכחתם סיסמה?״.`)
};

const af_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hierdie rekening is reeds opgestel. Meld aan of gebruik Wagwoord vergeet.`)
};

const hu_auth_error_already_claimed = /** @type {(inputs: Auth_Error_Already_ClaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez a fiók már be van állítva. Jelentkezzen be, vagy használja az Elfelejtett jelszó funkciót.`)
};

/**
* | output |
* | --- |
* | "This account is already set up. Sign in or use Forgot password." |
*
* @param {Auth_Error_Already_ClaimedInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_error_already_claimed = /** @type {((inputs?: Auth_Error_Already_ClaimedInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_Already_ClaimedInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_error_already_claimed(inputs)
	if (locale === "de") return de_auth_error_already_claimed(inputs)
	if (locale === "zh") return zh_auth_error_already_claimed(inputs)
	if (locale === "ar") return ar_auth_error_already_claimed(inputs)
	if (locale === "fr") return fr_auth_error_already_claimed(inputs)
	if (locale === "vi") return vi_auth_error_already_claimed(inputs)
	if (locale === "sw") return sw_auth_error_already_claimed(inputs)
	if (locale === "th") return th_auth_error_already_claimed(inputs)
	if (locale === "bs") return bs_auth_error_already_claimed(inputs)
	if (locale === "ja") return ja_auth_error_already_claimed(inputs)
	if (locale === "ko") return ko_auth_error_already_claimed(inputs)
	if (locale === "pt") return pt_auth_error_already_claimed(inputs)
	if (locale === "it") return it_auth_error_already_claimed(inputs)
	if (locale === "sv") return sv_auth_error_already_claimed(inputs)
	if (locale === "nl") return nl_auth_error_already_claimed(inputs)
	if (locale === "da") return da_auth_error_already_claimed(inputs)
	if (locale === "nb") return nb_auth_error_already_claimed(inputs)
	if (locale === "fi") return fi_auth_error_already_claimed(inputs)
	if (locale === "pl") return pl_auth_error_already_claimed(inputs)
	if (locale === "ru") return ru_auth_error_already_claimed(inputs)
	if (locale === "tr") return tr_auth_error_already_claimed(inputs)
	if (locale === "hi") return hi_auth_error_already_claimed(inputs)
	if (locale === "id") return id_auth_error_already_claimed(inputs)
	if (locale === "ms") return ms_auth_error_already_claimed(inputs)
	if (locale === "cs") return cs_auth_error_already_claimed(inputs)
	if (locale === "el") return el_auth_error_already_claimed(inputs)
	if (locale === "he") return he_auth_error_already_claimed(inputs)
	if (locale === "af") return af_auth_error_already_claimed(inputs)
	if (locale === "hu") return hu_auth_error_already_claimed(inputs)
	return en_auth_error_already_claimed(inputs)
});